import axios from 'axios'

class BillDetailTypeFactory {
  async get () {
    try {
      const url = '/bill_detail_types'
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async create (data: any) {
    try {
      const url = '/bill_detail_types'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async update (id: any, data: any) {
    try {
      const url = '/bill_detail_types/' + id
      const response = await axios.put(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export const billDetailTypeFactory = new BillDetailTypeFactory()
